import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { GenderReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class GenderReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/GenderReferences';
    private _genderReference = new BehaviorSubject<GenderReferenceModel[]>(null);

    get genderReference() {
        return this._genderReference.asObservable();
    }

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getGenderReferences(): Observable<GenderReferenceModel[]> {
        return this.httpGet<GenderReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                tap(res => this._genderReference.next(res.body)),
                map(res => res.body)
            )
    }
}